import { gql } from '@apollo/client'

export default gql(`
mutation createGenre($name: String!, $project: String) {
    createGenre(
        input: {
            name: $name
        },
        project: $project
    ) {
        id
        name
        source
        assetCount
    }
}`
)
